import { AppPlaceholder } from '@repo/ui/components';

export function RootFallback() {
  return <AppPlaceholder loading />;
}
